import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private androidPermissions: AndroidPermissions,
    private alertController: AlertController
  ) {}

  async checkNotificationPermission(attempts: number = 1): Promise<void> {
    // Verifica se o objeto cordova está disponível
    if (typeof window['cordova'] === 'undefined') {
      console.warn('Cordova não disponível, pulando verificação de permissão de notificações.');
      return;
    }
    
    const permission = 'android.permission.POST_NOTIFICATIONS';
  
    try {
      const result = await this.androidPermissions.checkPermission(permission);
      if (!result.hasPermission) {
        if (attempts <= 2) {
          const requestResult = await this.androidPermissions.requestPermission(permission);
          if (!requestResult.hasPermission) {
            this.checkNotificationPermission(attempts + 1);
          }
        } else {
          await this.showAlert(
            'Ative as notificações!',
            'Assim, você será avisado sempre que receber uma mensagem ou quando suas datas forem confirmadas — garantindo que fique no controle da sua viagem!'
          );
          this.openAppSettings();
        }
      }
    } catch (error) {
      console.error('Erro ao verificar permissão de notificações:', error);
    }
  }
  

  private async showAlert(header: string, message: string) {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: ['OK']
    });
    await alert.present();
  }

  private openAppSettings() {
    window.open('app-settings:', '_system');
  }
}
